export default "__VITE_ASSET__CZpLzHJC__"